import React, {Component} from 'react';
import {deepCopyObject} from "../helper/helper";

class InlineError extends Component {

	constructor(props) {
		super(props);

		this.state={
			divStyle: {textAlign: 'center'},
			labelStyle: {color: 'red', borderRadius: '3px'}
		}
	}

	componentDidMount() {
		this.updateDivStyle();
	}

	updateDivStyle() {
		let divStyle = deepCopyObject(this.state.divStyle);
		let newDivStyle = this.props.parentDivStyle ? Object.assign({}, divStyle, this.props.parentDivStyle) : divStyle;
		this.setState({divStyle: newDivStyle});
	}

	render() {
		return (
			<div className={this.props.className} style={this.state.divStyle}>
				{this.props.errorObject.show &&
				<label style={this.state.labelStyle}>{this.props.errorObject.message}</label>}
			</div>
		)
	}
}

export default InlineError;